export const CHAT_ATTACHMENT_CHIP_BORDER_RADIUS = "md"
export const CHAT_ATTACHMENT_PENDING_PREVIEW_SIZE_PX = 28
export const CHAT_ATTACHMENT_INLINE_ICON_SIZE_PX = 14
export const CHAT_ATTACHMENT_MESSAGE_IMAGE_MAX_WIDTH_PX = 200
export const CHAT_ATTACHMENT_MESSAGE_IMAGE_MAX_HEIGHT_PX = 128
